import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { useHelpRef } from '~/systems/help';
import CloudControl from '../CloudControl/CloudControl';
import LocalEmulationControl from '../LocalEmulationControl/LocalEmulationControl';
import Tabs from '../Tabs/Tabs';
import './ExperimentRunControl.css';

function SimControlWrapper() {
  const helpRef = useHelpRef<HTMLDivElement>('sim-control');
  return (
    <div ref={helpRef} className="ExperimentRunControl">
      <LocalEmulationControl />
    </div>
  );
}

export default function ExperimentRunControl() {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('job') ? 1 : 0);

  return (
    <Tabs
      tabs={['Local emulation', 'Cloud emulation']}
      activeTab={activeTab}
      onClickTab={setActiveTab}
    >
      {activeTab === 0 && <SimControlWrapper />}
      {activeTab === 1 && <CloudControl />}
    </Tabs>
  );
}
